export default __webpack_public_path__ + "static/media/icon-pending.a166671e.svg";